import React from 'react';
import './index.scss';
import CloudinaryImage from '@stubhub/react-cloudinary';
import {SellPartnersConfig as images} from '../react-sell-partners/config';
import {FormattedMessage} from 'react-intl';
import {Text} from '../../common/gutenberg';

const Partners = ({shstoreId}) => (
  <div className="Partners__container">
    <Text component='h3' className="Partners__msg">
      <FormattedMessage id="Partners.Header.msg" defaultMessage="Trusted by" />
    </Text>
    <div className="Partners__imageContainer">
      {images[shstoreId].map(
        ({src, alt, type}, idx) => {
          return (
            <figure className={`Partners__figure ${type}`} key={`container-${idx}`}>
              <CloudinaryImage
                className={`Partners__image ${type}`}
                src={src}
                alt={alt}
                key={`${idx}-${src}`}
                onError={(event) => (event.target.classList.add("Partners__errorCss"))}
                enableCloudinary={true}
                editZoomUrl={false}
                useNamedTransforms={false}
              />
            </figure>
          );
        }
      )}
    </div>
  </div>
);

export default Partners;
